import { AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { ChartRendererService } from '../../../../my-shared-lib/src/lib/shared-services/chart-renderer.service';
import { Subscription } from 'rxjs';
import { ConfigService } from '../../../../my-shared-lib/src/lib/shared-services/config.service';


@Component({
  selector: 'app-widget-renderer',
  imports: [],
  standalone: true,
  templateUrl: './widget-renderer.component.html',
  styleUrl: './widget-renderer.component.scss'
})
export class WidgetRendererComponent implements AfterViewInit, OnDestroy {
  @Input() charts!: any
  @ViewChildren('chartContainer', { read: ViewContainerRef })
  chartContainers!: QueryList<ViewContainerRef>;
  subscription!: Subscription;


  constructor(
    private chartRendererService: ChartRendererService,
    private configService: ConfigService
  ) { }

  ngAfterViewInit(): void {
    if (this.chartContainers.length > 0) {
      const container = this.chartContainers.first;
      const chart = this.charts;
      if (chart) {
        this.chartRendererService.renderChart(chart.type, container, chart);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

